<template>
  <button-dropdown :infos="infos" :defaultOption="limit" @change="changePage"/>
</template>

<script>
  import cookie from 'vue-cookie'
  import ButtonDropdown from '@/components/template/ButtonDropdown'

  export default {
    data: () => ({
      infos: {
        label: 'quantityItensPage',
        identifier: 'sort-numeric',
        icon: 'icon-sort-numeric-asc',
        options: [15, 30]
      },
      created: false,
      limit: 15
    }),
    created () {
      if (cookie.get('limit')) {
        this.limit = parseInt(cookie.get('limit'))
      }
    },
    mounted () {
      this.created = true
      this.$emit('change', this.limit)
    },
    methods: {
      changePage (page) {
        this.limit = page
        cookie.set('limit', page)
        this.$emit('change', this.limit)
      }
    },
    components: {
      ButtonDropdown
    }
  }
</script>



// WEBPACK FOOTER //
// SortNumeric.vue?d4d2d224